import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";

import { merchants as MERCHANT_LIST } from "@flexa/merchants";

import { SortAndroid } from "../../components/SortAndroid";
import { useIsDarkMode } from "../../hooks/useIsDarkMode";
import { useIsIOS } from "../../hooks/useIsIOS";
import { useTheming } from "../../hooks/useTheming";

const PayWithFlexa = () => {
  const [sortOption, setSortOption] = useState("popular");
  const [merchantList, setMerchantList] = useState(MERCHANT_LIST);
  const isIOS = useIsIOS();
  const isDark = useIsDarkMode();
  const [styles, theme] = useTheming();

  useEffect(() => {
    document.getElementsByName("theme-color")[0].setAttribute("content", isDark ? "#000" : "#fff");
  }, [isDark]);

  const handleSort = (sort) => {
    setSortOption(sort);
    if (sort === "popular") {
      setMerchantList(MERCHANT_LIST);
    } else if (sort === "az") {
      const sortedArray = [...MERCHANT_LIST].sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });

      setMerchantList(sortedArray);
    }
  };

  const handleMerchantClick = (merchant) => {
    const a = document.createElement("a");
    a.href = `/directory/${merchant.id}?nb=1`;
    a.click();
  };

  const memoizedMerchants = useMemo(
    () =>
      merchantList.map((merchant, index) => (
        <div key={index} className={styles.listItem} onClick={() => handleMerchantClick(merchant)}>
          <div>
            <div
              className={styles.merchantLogo}
              style={{
                background: `url('${merchant.logoUrl}')`,
              }}
            />
          </div>
          <div className={styles.merchantTitle} style={{ color: theme?.titleColor }}>
            <div>{merchant.name}</div>
          </div>
        </div>
      )),
    [merchantList, styles.listItem, styles.merchantLogo, styles.merchantTitle, theme?.titleColor],
  );

  return (
    <>
      <style>
        {`
            html {
              background-color: ${
                isIOS
                  ? isDark
                    ? theme?.backgroundColor || "rgba(0, 0, 0, 0.96)" // Dark mode on iOS
                    : theme?.backgroundColor || "rgba(0, 0, 0, 0.04)" // Light mode on iOS
                  : isDark
                    ? theme?.backgroundColor || "rgba(19, 19, 22, 0.96)" // Dark mode on non-iOS
                    : theme?.backgroundColor || "rgba(252, 248, 253, 0.5)" // Light mode on non-iOS
              };
            }
        `}
      </style>
      <meta
        content="width=device-width, initial-scale=1.0, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0"
        name="viewport"
      />
      <Helmet title="Places to Pay" />
      <div className={styles.container}>
        <div className={styles.containerGroupDirectory}>
          <div className={styles.sortBox}>
            <div className={styles.listHeading}>Now available at</div>
            <div className={styles.sortText} style={{ color: theme?.sortTextColor }}>
              <select
                style={{
                  display: "flex",
                  width: "80px",
                  marginLeft: "-20px",
                  position: "absolute",
                  opacity: "0.01",
                }}
                onChange={(e) => handleSort(e?.target?.value)}
              >
                <option value="popular">Most Popular</option>
                <option value="az">A to Z</option>
              </select>
              {sortOption === "popular" ? "Sort" : "A to Z"}{" "}
              {isIOS ? <>&#8645;</> : <SortAndroid fill={theme?.titleColor} />}
            </div>
          </div>
        </div>
        <div className={styles.listContainer}>{memoizedMerchants}</div>
      </div>
    </>
  );
};

export default PayWithFlexa;
